import React, {Component} from 'react';
import {
    checkAttributeFilter,
    checkSpecificationFilter,
    clearAllFilters,
    initializeFilters,
    setOrderBy,
} from "../store/filters/actions";
import {connect} from "react-redux";
import styled from 'styled-components';
import withStore from "../hoc/withStore";
import {createStructuredSelector} from "reselect";
import {
    selectActiveFiltersCount,
    selectAttributeFiltersJS,
    selectHasActiveFilters, selectHasDiscountFilter,
    selectIsDiscountFilterChecked,
    selectSelectedSortOption,
    selectSortOptionsJS,
    selectSpecificationFiltersJS
} from "../store/filters/selectors";
import FilterList from "./FilterList";
import {DISCOUNTED_ATTRIBUTE_ID} from "../models/constants";
import FilterListHeader from "./FilterListHeader";
import BodyScrollLocker from "../elements/BodyScrollLocker";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSlidersH,faSortAlphaDown,faPercent,faCheck} from '@fortawesome/pro-light-svg-icons';

const MobileWrapper = styled.div`
    box-shadow: 0px -3px 10px 0px rgba(0,0,0,0.30);
`;

const HiddenSelect = styled.select`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    font-size: 40px;
`;

const ScrollableContainer = styled(BodyScrollLocker)`
    overflow-y: scroll;
`;

function getCategoryContextFilter() {
    try {
        const categoryContextFilterElement = document.getElementById('categoryContextFilter');
        return JSON.parse(categoryContextFilterElement.innerText);
    } catch (err) {
        return null;
    }
}

class Filters extends Component {

    state = {
        filterOpened: false,
    };

    componentDidMount() {
        const {initialAttributeFilters, initialSpecificationFilters, categoryId, initializeFilters} = this.props;
        const categoryContextFilter = getCategoryContextFilter();
        initializeFilters(initialAttributeFilters, initialSpecificationFilters, categoryId, categoryContextFilter);
    }

    openFilters = () => {
        this.setState({
            filterOpened: true,
        });
    };

    closeFilters = () => {
        this.setState({
            filterOpened: false,
        });
    };

    onSpecificationFilterChanged = (filterId, filterItemId) => {
        const {checkSpecificationFilter} = this.props;
        checkSpecificationFilter(filterId, filterItemId);
    };

    onAttributeFilterChanged = (filterId, filterItemId, isChecked) => {
        const {checkAttributeFilter} = this.props;
        checkAttributeFilter(filterId, filterItemId, isChecked);
    };

    onOrderChanged = (e) => {
        const {setOrderBy} = this.props;
        setOrderBy(e.target.value);
    };

    onDiscountChanged = () => {
        const {checkSpecificationFilter} = this.props;
        checkSpecificationFilter(DISCOUNTED_ATTRIBUTE_ID, DISCOUNTED_ATTRIBUTE_ID);
    };

    render() {
        const {
            title,
            hasActiveFilters,
            clearAllText,
            clearAllFilters,
            sortOptions,
            selectedSortOption,
            filterCount,
            attributeFilters,
            specificationFilters,
            filtersButtonTitle,
            orderByButtonTitle,
            discountButtonTitle,
            applyFiltersButtonTitle,
            isDiscountFilterChecked,
            hasDiscountFilter,
        } = this.props;
        const {
            filterOpened
        } = this.state;

        return <>
            <MobileWrapper
                className="position-fixed bottom left zindex-6000 w-100 bg-white border-top box-shadow d-md-none">
                <div
                    className="row no-gutters justify-content-center align-items-center text-center text-uppercase font-size-0-625">
                    <div className="col p-2 d-flex flex-column align-items-center" onClick={this.openFilters}>
                        <FontAwesomeIcon icon={faSlidersH} className="font-size-1-25 text-primary" />
                        {filtersButtonTitle}{filterCount > 0 && ` (${filterCount})`}
                    </div>
                    <div className="col border-left p-2 d-flex flex-column position-relative align-items-center">
                        <FontAwesomeIcon icon={faSortAlphaDown} className="font-size-1-2 text-primary" />
                        {orderByButtonTitle}
                        <HiddenSelect value={selectedSortOption || 0} onChange={this.onOrderChanged}>
                            {sortOptions && sortOptions.map(option => <option key={option.Value}
                                                                              value={option.Value}>{option.Text}</option>)}
                        </HiddenSelect>
                    </div>
                    {hasDiscountFilter &&
                    <div className="col border-left p-2 d-flex flex-column align-items-center" onClick={this.onDiscountChanged}>
                        <FontAwesomeIcon icon={faPercent} className="font-size-1-25 text-pink" />
                        <div className="text-nowrap">
                            {discountButtonTitle}
                            {isDiscountFilterChecked && <FontAwesomeIcon icon={faCheck} className="ml-1" />}
                        </div>
                    </div>
                    }
                </div>
            </MobileWrapper>
            <div className="d-none d-md-block">
                <FilterListHeader title={title}
                                  showClearFilters={hasActiveFilters}
                                  onClearFiltersClicked={clearAllFilters}
                                  clearAllText={clearAllText}/>
                <FilterList specificationFilters={specificationFilters}
                            attributeFilters={attributeFilters}
                            onSpecificationFilterChanged={this.onSpecificationFilterChanged}
                            onAttributeFilterChanged={this.onAttributeFilterChanged}/>
            </div>
            <div
                className={`${filterOpened ? 'd-flex d-md-none' : 'd-none'} flex-column p-2 position-fixed top left bottom right bg-white zindex-7000`}>
                <FilterListHeader title={title}
                                  showClearFilters={hasActiveFilters}
                                  onClearFiltersClicked={clearAllFilters}
                                  clearAllText={clearAllText}/>
                <ScrollableContainer className="flex-fill mb-2" enabled={filterOpened ? 1 : 0}>
                    <FilterList specificationFilters={specificationFilters}
                                attributeFilters={attributeFilters}
                                onSpecificationFilterChanged={this.onSpecificationFilterChanged}
                                onAttributeFilterChanged={this.onAttributeFilterChanged}/>
                </ScrollableContainer>
                <div onClick={this.closeFilters}
                     className="btn btn-lg btn-primary d-block">
                    {applyFiltersButtonTitle}
                </div>
            </div>
        </>
    }
}

const mapStateToProps = createStructuredSelector({
    specificationFilters: selectSpecificationFiltersJS,
    attributeFilters: selectAttributeFiltersJS,
    filterCount: selectActiveFiltersCount,
    hasActiveFilters: selectHasActiveFilters,
    hasDiscountFilter: selectHasDiscountFilter,
    isDiscountFilterChecked: selectIsDiscountFilterChecked,
    sortOptions: selectSortOptionsJS,
    selectedSortOption: selectSelectedSortOption,
});

const mapDispatchToProps = dispatch => {
    return {
        clearAllFilters: () => dispatch(clearAllFilters()),
        initializeFilters: (attributeFilters, specificationFilters, categoryId, categoryContextFilter) => dispatch(initializeFilters(attributeFilters, specificationFilters, categoryId, categoryContextFilter)),
        checkSpecificationFilter: (filterId, filterItemId, isChecked) => dispatch(checkSpecificationFilter(filterId, filterItemId, isChecked)),
        checkAttributeFilter: (filterId, filterItemId, isChecked) => dispatch(checkAttributeFilter(filterId, filterItemId, isChecked)),
        setOrderBy: (orderBy) => dispatch(setOrderBy(orderBy)),
    }
};

export default withStore(connect(mapStateToProps, mapDispatchToProps)(Filters));
